import { render } from "./UserMenu.vue?vue&type=template&id=fb8cdfd6&ts=true"
import script from "./UserMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserMenu.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/UserMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb8cdfd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb8cdfd6', __exports__)) {
    console.log('reload')
    api.reload('fb8cdfd6', __exports__)
  }
  
  module.hot.accept("./UserMenu.vue?vue&type=template&id=fb8cdfd6&ts=true", () => {
    console.log('re-render')
    api.rerender('fb8cdfd6', render)
  })

}


export default __exports__